<template>
  <div class="new-detail">
    <div class="detail-back">
      <i class="el-icon-back" @click="goBack"></i>
      <div class="detail-text">{{ detailInfo.source }}</div>
      <div class="detail-date">{{ detailInfo.date }}</div>
    </div>
    <div class="detail-title">{{ detailInfo.title }}</div>
    <div class="detail-content">
      <div class="content-left">
        <div class="follow">关注公众号</div>
        <div class="follow-desc">获取更多智慧管理产品及解决方案</div>
        <el-image class="QR-img" :src="QRCode"></el-image>
        <enoContract :source="'news'"></enoContract>
      </div>
      <div class="content-right" v-html=docContent>
      </div>
    </div>
  </div>
</template>

<script>
import enoContract from '../common/eno-contract.vue'
import { config } from "./js/news_information";

export default {
  name: '',
  components: { enoContract },
  data() {
    return {
      config: config,
      // moreCase: config1.moreCase,
      detailInfo: {
        date: '',
        title: '',
        source: ''
      },
      QRCode: require('@/assets/images/about/code.png'),
      docContent: ''
    };
  },
  computed: {},
  mounted() {
    // 动态加载html文档
    this.loadDocByQueryParam()
  },

  methods: {

    goBack() {
      this.$router.go(-1);
    },
    async loadDocByQueryParam() {
      this.detailInfo = this.$route.query;
      const fileName = this.detailInfo.fileName
      if (!fileName) {
        this.docContent = '未获取到有效的文档名称'
        return
      }
      try {
        // const docModule = await import(`/public/docHtml/${this.detailInfo.source}/${fileName}`)
        const response = await fetch(`/docHtml/${this.detailInfo.source}/${fileName}`);
        if (!response.ok) throw new Error('文件不存在');

        const text = await response.text();
        let content = "";

        // 情况1：匹配 export default { content: `...` }
        const objContentMatch = text.match(/content:\s*`([\s\S]*?)`/);
        if (objContentMatch) {
          content = objContentMatch[1];
        } else {
          //  情况2：匹配 export default `...` 或 export default { ... }
          const defaultMatch = text.match(/export default\s*([`'"])([\s\S]*?)\1/);
          if (defaultMatch) {
            content = defaultMatch[2];
          } else {
            // 如果是直接 export default 字符串，就去掉 export default 前缀
            content = text.replace(/export\s+default\s+/, "").replace(/^`|`$/g, "");
          }
        }
        this.docContent = content
      } catch (error) {
        this.docContent = `文档加载失败，请检查文件名是否正确`
      }
    }
  },
};
</script>

<style scoped lang="less">
.new-detail {
  padding: 40px 68px;

  .detail-back {
    display: flex;
    align-items: center;

    .el-icon-back {
      font-size: 24px;
      cursor: pointer;
    }

    .detail-text {
      margin: 0 10px;
      font-size: 24px;
    }
  }

  .detail-title {
    margin: 30px 0 120px;
    font-size: 50px;
    width: 65%;
  }

  .detail-content {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-column-gap: 128px;

    .content-left {
      color: @mainBgColor;

      .follow {
        font-size: 40px;
      }

      .follow-desc {
        font-size: 20px;
        margin: 24px 0;
      }

      .QR-img {
        width: 124px;
        height: 124px;
        margin-bottom: 40px;
      }
    }

    .content-right {
      line-height: 32px;
    }
  }
}

@media @mobile {
  .new-detail {
    padding: @commonPadding_h5;

    .detail-back {
      display: flex;
      align-items: center;

      .el-icon-back {
        font-size: 24px;
        cursor: pointer;
      }

      .detail-text {
        margin: 0 10px;
        font-size: 24px;
      }
    }

    .detail-title {
      margin: 20px 0;
      font-size: 24px;
      font-weight: 600;
      width: 92vw;
    }

    .detail-content {
      display: block;

      .content-left {
        display: none;
      }

      .content-right {
        line-height: 32px;
      }
    }
  }
}
</style>
